import MutableTrack from './MutableTrack.js';
import * as Tone from 'tone';
import {setEffectParameterValues} from 'actions/index.js';
import {Z4} from 'constants/track-types.js';

const PARAMS = ["Mutate", "Duration"];
/**
 * A Z4 track is used for controlling up to 4 parameters
 * from ANY tracks in the sequence
 * For example, with a Z4 track you can mutate the parameters
 * of a synth in a rhythmic manner
 */
class Z4Track extends MutableTrack {
    constructor(
        trackNumber,
        sequencerEngine,
        mixSession,
        numberOfPatterns,
        update,
        subSequence) {
        super(trackNumber, sequencerEngine, mixSession, numberOfPatterns, update, subSequence);

        this.controlParameters = [];
    }

    getName() {
        return "Z4 Control";
    }

    getTrackType() {
        return Z4;
    }

    trigger(stepData, time, step) {
        if (stepData.mutate === null) {
            return;
        }
        let bulk = {};
        for (let parameter of this.controlParameters) {
            let _value = parameter.get();
            if (stepData.mutate < 0) {
                // how much is there between the min and value
                _value += (0.01 * stepData.mutate) * (_value - parameter.min)
            } else {
                _value += 0.01 * (stepData.mutate) * (parameter.max - _value)
            }
            if (_value <= parameter.max && _value >= parameter.min) {
                let {id, value} = parameter.set(_value, true, true, time);
                bulk[id] = value;
            }
        }

        
        this.store.dispatch(setEffectParameterValues(bulk));
    }

    triggerRelease(transpose) {
    }

    getStepDataParams() {
        return PARAMS;
    }
}

export default Z4Track;
